function r(o, e) {
  return Array.isArray(e) ? e.every((t) => o.indexOf(t) !== -1) : o.indexOf(e) !== -1;
}
const i = (o, e) => (t) => {
  (t.key === "Enter" || t.key === " ") && (o(t), t.preventDefault(), t.stopPropagation()), e && e(t);
}, c = (o) => {
  setTimeout(o, 0);
}, n = (o = document) => {
  const e = o.activeElement;
  return e ? e.shadowRoot ? n(e.shadowRoot) : e : null;
}, u = "@media (pointer: fine)";
export {
  u as DEFAULT_DESKTOP_MODE_MEDIA_QUERY,
  r as arrayIncludes,
  c as executeInTheNextEventLoopTick,
  n as getActiveElement,
  i as onSpaceOrEnter
};
//# sourceMappingURL=utils7.mjs.map
